import React from 'react';

interface CruiseImgProps {
    small?: boolean;
}

/**
 * Mayan-styled paddlewheel boat SVG icon for cruise tours
 * Design: Boat hull with stepped Mayan pyramid layers on deck
 */
function CruiseImg({ small }: CruiseImgProps) {
    const size = small ? 48 : 150;

    return (
        <svg
            width={size}
            height={size * 0.7}
            viewBox="0 0 160 100"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={{ display: 'block' }}
        >
            {/* Deck tiers */}
            <rect
                x="34"
                y="18"
                width="44"
                height="12"
                rx="2"
                fill="white"
                stroke="var(--clr-primary, #102f63)"
                strokeWidth="2.5"
            />
            <rect
                x="24"
                y="30"
                width="64"
                height="12"
                rx="2"
                fill="white"
                stroke="var(--clr-primary, #102f63)"
                strokeWidth="2.5"
            />
            <rect
                x="14"
                y="42"
                width="84"
                height="12"
                rx="2"
                fill="white"
                stroke="var(--clr-primary, #102f63)"
                strokeWidth="2.5"
            />

            {/* Hull */}
            <path
                d="M10 54 L148 54 L120 80 Q104 90 76 90 L28 90 Q6 78 8 70 Z"
                // d="M10 54 L118 54 L110 76 Q104 90 76 90 L28 90 Q6 88 8 70 Z"
                fill="white"
                stroke="var(--clr-primary, #102f63)"
                strokeWidth="2.5"
                strokeLinejoin="round"
            />
            {/* Bow curve */}
            <path
                d="M10 54 L30 54 L20 68 Q16 74 8 74 L6 74 Q2 72 4 66 L6 60 Q7 56 10 54 Z"
                fill="white"
                stroke="var(--clr-primary, #102f63)"
                strokeWidth="2.5"
                strokeLinejoin="round"
            />
            {/* Waterline */}
            {/* <line
                x1="14"
                y1="72"
                x2="112"
                y2="72"
                stroke="var(--clr-primary, #102f63)"
                strokeWidth="1.5"
            /> */}

            {/* Mayan Sun Paddle Wheel */}
            <g transform="translate(20, 60)">
                {/* Outer wheel with triangular rays */}
                <circle
                    cx="0"
                    cy="0"
                    r="20"
                    fill="white"
                    stroke="var(--clr-primary, #102f63)"
                    strokeWidth="2.5"
                />

                {/* Triangular sun rays (8 rays) */}
                <path d="M0 -20 L-4.5 -12 L4.5 -12 Z" fill="var(--clr-primary, #102f63)" />
                <path d="M0 20 L-4.5 12 L4.5 12 Z" fill="var(--clr-primary, #102f63)" />
                <path d="M-20 0 L-12 -4.5 L-12 4.5 Z" fill="var(--clr-primary, #102f63)" />
                <path d="M20 0 L12 -4.5 L12 4.5 Z" fill="var(--clr-primary, #102f63)" />
                <path d="M-14 -14 L-8 -8 L-12 -5 Z" fill="var(--clr-primary, #102f63)" />
                <path d="M14 14 L8 8 L12 5 Z" fill="var(--clr-primary, #102f63)" />
                <path d="M14 -14 L8 -8 L12 -5 Z" fill="var(--clr-primary, #102f63)" />
                <path d="M-14 14 L-8 8 L-12 5 Z" fill="var(--clr-primary, #102f63)" />

                {/* Inner face circle */}
                <circle
                    cx="0"
                    cy="0"
                    r="10"
                    fill="white"
                    stroke="var(--clr-primary, #102f63)"
                    strokeWidth="2"
                />

                {/* Mayan face - serious/stoic expression */}
                {/* Eyes - rectangular like classic Mayan art */}
                <rect x="-6" y="-4.5" width="4" height="3.5" fill="var(--clr-primary, #102f63)" />
                <rect x="2" y="-4.5" width="4" height="3.5" fill="var(--clr-primary, #102f63)" />

                {/* Nose - stepped/geometric */}
                <path d="M-2 0 L0 -1.5 L2 0 L2 3 L-2 3 Z" fill="var(--clr-primary, #102f63)" />

                {/* Mouth - straight serious line */}
                <line
                    x1="-4"
                    y1="6"
                    x2="4"
                    y2="6"
                    stroke="var(--clr-primary, #102f63)"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </g>

            {/* Paddle wheel connection to boat */}
            {/* <rect
                x="118"
                y="56"
                width="8"
                height="22"
                fill="white"
                stroke="var(--clr-primary, #102f63)"
                strokeWidth="2"
            /> */}
        </svg>
    );
}

export default CruiseImg;
